<template>
  <div class="education">
    <ul class="education_gresslist">
      <li v-for="(e,i) in baby" :key="i">
        <div class="level">
          <span>{{e.level}}</span>
        </div>
        <div class="gressbar">
          <div class="pergress" :style="{backgroundColor:e.bg}">
            <div class="progress" :style="{width:e.per,backgroundColor:e.coverbg}"></div>
          </div>
        </div>
        <div class="percent">
          <span>{{e.num}}</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props:{
    MeetingStat: {
      type: Object,
      default: {},
    },
  },
  watch: {
    "MeetingStat": function (val) {
      // console.log(val)
      this.getPercent(val)
    },
  },
  data(){
    return{
      level:[],
      num:[],
      per:[],
      baby:[]
    }
  },
  methods:{
    getPercent(val){
      // console.log(val)
      const bg = ['#144146','#144146','#144146','#144146','#144146','#144146','#144146','#144146']
      const coverbg = ['#46e890','#81faf6','#e7df62','#9ecdfc','#f8d5b2','#c8df78','#efa1a2','#eebb74','#f80af5','#d20d0d','#455705','#0012ff']
      let total = 0
      val.total.forEach(res => {
        total += res
      });
      this.level = val.xAxis 
      this.num = val.series 

      let per = []
      val.total.forEach(res => {
        console.log(res)
        res = Math.floor(res / total*100)+"%"
        per.push(res)
      });
      this.per = per

      let newArr = []
      val.xAxis.forEach(res => {
        let arr = {}
        arr.level = res
        newArr.push(arr)
      })
      newArr.forEach((res,i)=>{
        res.num = val.total[i]+"次"
        res.per = per[i]
        res.coverbg = coverbg[i]
        res.bg = bg[i]
      })

      this.baby = newArr
      console.log(1,this.baby)
      
    }
  },

}
</script>
<style lang="less" scoped>
.education{
  height: 100%;
  .education_gresslist{
    height: 100%;
    li{
      height: 8.3%;
      display: flex;
      color: #fff;
      font-size: calc(1 / 10.8 * 16vh);
      .level{
        width: 20%;
        height: 100%;
        text-align: right;
        display: flex;
        align-items: center;
        > span{
          width: 100%;
        }
      }
      .gressbar{
        flex: 1;
        display: flex;
        align-items: center;
        height: 100%;
        .pergress{
          height: calc(1 / 10.8 * 16vh);
          background: #144246;
          border-radius: calc(1 / 10.8 * 6vh);
          flex: 1;
          margin:0 10%;
          .progress{
            height: 100%;
            width: 0;
            background: #45e790;
            border-radius: calc(1 / 10.8 * 6vh);
          }
        }
      }
      .percent{
        width: 20%;
        height: 100%;
        text-align: left;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Echarts/YearMeetingChart.vue